/**
 * export page data in csv
 * @param {String} name - name of exported file
 * @param {Array} data - array including arbitrary page data
 */
export default function (name, data) {
  if (!data || !Array.isArray(data)) {
    return
  }
  name = name.length ? `${name}.csv` : 'export.csv'
  var csvData = new Blob([data.map(e => e.join(',')).join('\n')], { type: 'text/csv' })
  var csvUrl = URL.createObjectURL(csvData)
  const link = document.createElement('a')
  link.setAttribute('href', csvUrl)
  link.setAttribute('download', name)
  document.body.appendChild(link) // Required for FF
  link.click()
  document.body.removeChild(link)
}
